export default "__VITE_ASSET__C8wupFn1__"